export const CLEANUP_SIGN_UP_STATE = 'cleanup-sign-up-state';
const cleanupSignUpState = () => ({ type: CLEANUP_SIGN_UP_STATE });
export default cleanupSignUpState;
